import React, {PureComponent} from "react"
import {Grid} from "react-bootstrap"

import {SecondaryNavWrapper} from "../styled"
import SecondaryNavContext from "../shared/SecondaryNavContext"

interface Props {
  brandColor: string
  pathname: string
}

class SecondaryNav extends PureComponent<Props> {
  render() {
    const {brandColor, pathname} = this.props

    return (
      <SecondaryNavWrapper brandColor={brandColor}>
        <Grid>
          <SecondaryNavContext pathname={pathname} />
        </Grid>
      </SecondaryNavWrapper>
    )
  }
}

export default SecondaryNav
